module.exports = __webpack_public_path__ + "img/wh_logo_purple.6ddbc4fa.svg";